export default __webpack_public_path__ + "d3832915380b0a70095ca59d4fa969c2.png";